import LcabApiRequest from "~/cabinet/ts/api/LcabApiRequest";
import {OrgDetailsForDisplayInterface} from "~/cabinet/vue/interface/documents/Interface";

export const AGENT_ACT_DOCUMENT_TYPE_ID = "agentAct";
export const CONTRACT_DOCUMENT_TYPE_ID = "contract";
export const ACT_DOCUMENT_TYPE_ID = "act";
export const BILL_DOCUMENT_TYPE_ID = "bill";
export const REC_ACT_DOCUMENT_TYPE_ID = "recAct";

export const DOCUMENT_LIST_MASS_ACTION_DOWNLOAD = "download";
export const DOCUMENT_LIST_MASS_ACTION_CHANGE_STATUS = "changeStatus";
export const DOCUMENT_LIST_MASS_ACTION_PREPARE_FOR_LETTER = "prepareForLetter";


export interface DocumentInterface {
    id: string;
    numberDescr: string;
    documentDate: string;
    organization: {
        id: string
        ocode?: string;
        descr?: string;
    };
    details?: OrgDetailsForDisplayInterface;
    dealerDetails?: OrgDetailsForDisplayInterface;
    edo?: {
        isUseEdo: boolean,
        status?: {
            id: string,
            descr: string,
            color: string,
            rejectStatusDescr?: string,
            isCanResend: boolean
        },
        pdfUrl?: string
    };
    isEditable: boolean;
    status: {
        descr: string;
        dateTime: string;
        isEditable: boolean;
        color: string;
        isReject: boolean;
        errorDescr?: string;
    };
    nextStatus?: {
        id: string,
        descr: string,
        dateTime: string
    };
    additionalSelection: any;
    scan?: string;
    scanInfo?: DocumentScanInterface;
    statusHistory: {
        color: string;
        dateTime: string;
        descr: string;
        manager?: string;
    }[];
    url?: string;
    inlineUrl?: string;
    xmlUrl?: string;
}

export interface DocumentScanInterface {
    dateTimeCreate: string;
    status?: {
        descr: string;
        errorDescr: string;
        isNeedErrorDescr: boolean;
        isSuccess: boolean;
        isModerate: boolean;
        isReject: boolean
    }
}

export interface FinanceDocumentInterface extends DocumentInterface {
    sum: number;
    currencyId: string;
    isWhite: boolean;
    isUslugaDescrEditable: boolean;
}

export interface BillInterface extends FinanceDocumentInterface {
    paymentStatus?: {
        descr: string;
        color: string;
        isPaid: boolean;
        isPartPaid: boolean;
    };
    isTarifLineCredit: boolean;
    acts: ActInterface[];
    paidSum: number;
    unpaidSum: number;
}

export interface AgentActInterface extends FinanceDocumentInterface {

}

export interface ActInterface extends FinanceDocumentInterface {
    descr: string;
    buhHeldStatus?: {
        color: string;
        descr: string;
    };
    spentSumByThisPayment?: number;
    actTypeTag?: string;
}

export interface ReceiptInterface {
    id: string;
    descr: string;
    url?: string;
    status?: {
        id: string;
        descr: string;
        color: string;
    }
}


export interface RecActInterface extends FinanceDocumentInterface {
    dateStart: string;
}


export function getDocumentDownloadUrl(documentTypeId: string, documentId: string): string {
    return LcabApiRequest.getUrl(`/api/dealer/documents/${documentTypeId}/list/${documentId}/downloadDocument`);
}

export interface DocumentListExposeInterface {
    reload: () => void,
    selectMassAction: (actionId: string, parent?: DocumentInterface) => void,
    deleteDocument: (document: DocumentInterface) => Promise<void>
}